import { render, staticRenderFns } from "./ModalFAQs.vue?vue&type=template&id=7acd2dcd&"
import script from "./ModalFAQs.vue?vue&type=script&lang=js&"
export * from "./ModalFAQs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports